// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> aion-management-comfy -> harborstone
// Generated: 2026-10-28T20:49:33.164Z
// Counts: 5 design, 69 content, 56 slot group, 1 collection binding, 9 section, 5 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Accessibility",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Apply Now",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Welcome To</span></h1><h1><span style=\"font-size: 48px;\"><span data-type=\"field-token\" data-field=\"property_name\"></span></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Interactive Map",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Pet Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Privacy Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace a Life You’ll Love in Our Charming Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Schedule a Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Virtual Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed for Comfort & Convenience</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Start Your Application at Harborstone</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Speak with Our Leasing Team</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Transparent pricing for <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Fee Information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio, 1, 2 & 3 Bedroom Apartments in Newport News, VA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Interior & Community Highlights</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Easy Online Leasing at Harborstone</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the Harborstone Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Pet-Friendly Apartments in Newport News, VA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Your pet belongs <em>here, too.</em></h3><h3></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our wide array of spacious floor plans and find your perfect landing place in <a href=\"/featuring/newport-news-park-local-apartments-harborstone-697\">Newport News at Harborstone</a>. Our pet-friendly community provides a comfortable retreat with a host of upgrades plus friendly neighborhood vibes at an affordable price. Here, you can get to know your neighbors and relax in welcoming community spaces. &nbsp; &nbsp;</p><p>Situated near <a href=\"/neighborhood\">major highways and employers</a>, Harborstone offers a lifestyle where work and play are right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Convenient Resident Services</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.heading": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-form.talk_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour at Harborstone Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore from Anywhere</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Harborstone in Newport News, VA, where comfort meets convenience. Choose from a variety of <a href=\"/floor-plans\">floor plans, including studios and spacious three-bedrooms</a>. Enjoy vibrant resident activities, a dog park, and a state-of-the-art fitness center. Experience refined living with our premium renovations and unbeatable amenities today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Harborstone in Newport News, VA, your dream home awaits! Choose from stylish studios to spacious three-bedroom floor plans, all enhanced by premium renovations. Enjoy a vibrant community with resident activities, a fitness center, and a pet-friendly dog park. Lease online today and embrace the lifestyle you've always wanted!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Harborstone in Newport News, VA, your ideal living space awaits. Choose from our stylish floor plans—ranging from cozy studios to spacious three-bedroom apartments. Each design harmoniously blends comfort and modernity. Ready to elevate your lifestyle? Browse our available apartment homes today and find the perfect fit for you!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Harborstone in Newport News, VA, vibrant living meets modern convenience. Immerse yourself in stylish floor plans, from cozy <a href=\"/floor-plans\">studios to spacious three-bedroom apartments</a>. Our community boasts <a href=\"/amenities\">exceptional amenities</a> like a playful dog park, inviting clubhouse, and high-speed internet. Picture yourself here, where life feels effortlessly seamless!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.name": {
    "overrideType": "VALUE",
    "customValue": "Harborstone Apartments",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy our Studio, 1, 2 & 3 Bedroom Apartments in Newport News, Virginia!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Harborstone in Newport News, VA, enjoy a vibrant community surrounded by access to premier educational institutions like Christopher Newport University and excellent parks like Riverview Farm Park. Embrace a lifestyle where culture meets convenience, with the Mariners' Museum nearby, inviting you to soak in local history and nature.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. One-time non‑refundable fee: $350 for the first pet, $150 for the second. Monthly pet rent: $55 per pet.</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Harborstone in Newport News, VA, where your comfort meets convenience. Choose from our diverse floor plans, including studio, one, two, and three-bedroom apartments. Enhance your experience—log in to the resident portal to effortlessly pay rent, schedule maintenance, and stay connected with community updates.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "Download the Loft Resident Mobile App",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>At Harborstone in Newport News, VA, a variety of thoughtfully designed floor plans await, from cozy studios to spacious three-bedroom apartments. Immerse yourself in a community that values comfort and connection. Schedule a tour today and hear firsthand from our residents about their vibrant living experience!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Thank You",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Thank you for reaching out! At Harborstone in Newport News, VA, we offer a range of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments. Our team is excited to assist you on your journey to finding the perfect home. Stay tuned for our response!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Harborstone in Newport News, VA, your <a href=\"/home\">i</a> <a href=\"/featuring/three-bedroom-apartments-newport-news-city-harborstone-419\">deal apartment</a> awaits, from cozy studios to spacious three-bedroom layouts. Each <a href=\"/floor-plans\">floor plan</a> is designed with comfort in mind. Ready to envision your new home? Take a virtual tour today and step inside our vibrant community!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "residentaccess.login_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Access Resident Portal Login"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-81f6-7429-8928-e371d6423304.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern white kitchen with stainless steel fridge, stove, and sink. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-bf4b-70db-a786-9d9d2f6605ff.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with treadmills, elliptical, weight rack, and benches."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-e1df-7610-9b10-3a41fe48512b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge with a long white table, orange chairs, gray seating, and a wall-mounted TV."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-e362-7268-a9d4-fa3c9fdb6848.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community fitness room with treadmills, ellipticals, weights and mirrors."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166320/019d0267-e1df-7610-9b10-3a41fe48512b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Clubhouse lounge area with a communal table, seating, and a view into the fitness center."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-9082-706a-be6e-d6deb1c43c5b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern white kitchen with stainless steel appliances and marble countertops."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0264-a34a-76fc-8cbe-043c50be6a48.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in a modern apartment with a beige sofa, wooden armchair, coffee table, and a TV console."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-839b-7408-8443-843fedef9459.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in a modern apartment with a gray upholstered bed, nightstand, and window with blinds."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-e38f-7747-a4b1-52951c857b44.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a brick apartment building with a parking lot and trees. Welcome home to Harborstone Apartments, offering studio, 1, and 2-bedroom apartments for rent in New Port News, VA."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-f574-713f-95ee-f2cb46279be6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a brick apartment building with a parking lot and trees."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-fca2-73c1-b27f-6963e028b191.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two-story brick apartment building exterior with a wooden balcony, trimmed shrubs, and green lawn."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166320/019d0267-f54b-763d-a2d7-9f73abd333f1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings surrounded by lush green trees and a parking lot."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-ccdf-720e-ba9c-221b04c75bb0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor picnic pavilion with grills and a playground in the background."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-e6f0-722c-97d9-c3137fa4cdf0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Shaded pavilion with a picnic table and grills in a grassy communal area."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166320/019d0267-ca91-74ef-9256-6c0a90cdc2dc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park with agility equipment and a bench."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-c82e-765b-95d7-daff103f2866.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Orange playground slides in a sand area, surrounded by trees and grass."
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "additional": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.pet_fee_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "150"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$55"
      },
      "additional": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "25"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.washer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Washer/Dryer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$60"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-e362-7268-a9d4-fa3c9fdb6848.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community fitness room with treadmills, ellipticals, weights and mirrors."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-e1df-7610-9b10-3a41fe48512b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community lounge with a long white table, orange chairs, gray seating, and a wall-mounted TV."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0267-bbfe-70e5-a0f0-e5d860473f47.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern white kitchen with stainless steel fridge, stove, and sink."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019d0264-b057-723c-bbac-0259876ccd2c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with beige walls, neutral seating, a coffee table, and a sliding glass door with vertical blinds."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd920-f9c0-72cd-9d8a-445310a3b5ea.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Indulge Bakery & Bistro"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Breakfast"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.3 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual, family-run bistro specializing in breakfast classics, sandwiches and coffee drinks — a perfect way to start the day."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-49d1-7069-a099-5513d79404e6.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Patrick Henry Mall"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "The Peninsula's premier indoor mall, packed with popular stores, apparel, footwear and casual eateries for a full day of shopping."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-f1ea-7368-9db3-e47e67a3394e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Riverview Farm Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Park & Green Space"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.9 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sprawling green space with walking trails, a large playground, picnic areas and a seasonal sledding hill — ideal for a sunny afternoon outdoors."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-2b2c-7239-896b-e69a6d1a8a2c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "TASTE"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Market"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Beloved local cafe and market serving fresh sandwiches, salads and gourmet grab-and-go items in a relaxed, casual space."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-978e-70ce-ab2e-21a53faf20be.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Mariners' Museum and Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "One of the world's great maritime museums, home to remains of the ironclad USS Monitor and expansive exhibits on global seafaring history."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-0500-7291-a849-256fec2a6c44.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Newport News Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "One of the largest municipal parks in the country at 8,000+ acres, with disc golf, bike rentals, a boat ramp and miles of scenic trails."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-2fca-71d7-a293-494aa15c35f7.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cove Tavern"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Nightlife"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "American fare and cocktails in an airy space with tropical-inspired art and sidewalk seating — a laid-back spot for evening drinks."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-97f1-7558-9846-f6842fd234e2.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Ferguson Center for the Arts"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.3 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Modern concert hall and performing-arts theater hosting Virginia Symphony Orchestra performances, touring acts and live shows."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-17cb-720f-a443-b78edf7bc97d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Schlesinger's Steakhouse"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fine Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Traditional chophouse fare paired with a full bar and 150+ wines, served in refined, white-tablecloth surroundings."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd920-f9ba-7059-9e97-01047b584532.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Hilton Tavern Brewing Co."
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Brewery & Lounge"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "House-brewed beers, burgers and shareable bites in a relaxed tavern setting — a favorite late-night hangout in the Hilton Village area."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-a517-74e9-a696-b10175430741.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cinemark City Center and XD"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Modern multiplex with stadium seating, self-service kiosks and XD screens showing the latest new-release films."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd921-2a34-732f-8262-ad2d223b9786.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cure Coffeehouse"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Coffee & After-Hours"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual, modern coffeehouse for espresso drinks, teas and fresh bagels and muffins by the fountain — a cozy after-hours stop."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-a73d-707e-a3fb-e9bac2f6d4d9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a beige sofa, wooden coffee table, and a tall bookshelf beside a sliding glass door. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-81b1-709b-86f0-e17071ffd8c5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "White kitchen with white cabinets, marble-look countertops, and stainless steel appliances. Contact our leasing team at Harborstone Apartments today to schedule a tour of our studio, one-, and two-bedroom apartments in Newport News, VA."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166320/019fd922-d5be-7182-b87d-27a9d6d72608.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park with a sign, gazebo, and playground beyond, bordered by trees. Enjoy a pet-friendly community at Harborstone Apartments in Newport News, VA."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "homegallerypreview.photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingBottom": "30px"
    }
  },
  "hero.name": {
    "properties": {
      "paddingBottom": "50px"
    }
  },
  "propertyoverview.blurb": {
    "properties": {
      "fontWeight": "300"
    }
  },
  "residentaccess.app_heading": {
    "properties": {
      "fontWeight": "700"
    }
  }
};
